import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const AccessoriesTabWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${SPACING.SMALL_3};
`;

export const ProductGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: ${SPACING.SMALL_3};
    flex: 1;
    min-width: 0;
`;

export const ArrowButton = styled.button`
    flex: 0 0 auto;
    width: 40px;
    height: 40px;
    border: none;
    background: ${Colors.primary};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
        background: ${Colors.gray50};
        cursor: default;
    }
`;

export const IconContainer = styled.div`
    position: absolute;
    top: ${SPACING.SMALL_3};
    right: ${SPACING.SMALL_3};
    cursor: pointer;
`;
